import React from 'react';
import { QuantityOnOrder, Warehouse } from './common.types';
import Typography from '@mui/material/Typography';
import { useLocalization, useTranslate } from '@im/react-localization';
import { useFeatureFlag } from 'mf_core/feature-flag';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';

type Props = {
  ShowCentralStockTtypeSkuV2?: any;
  centralStock: number | false;
  localStock: number | false;
  productType?: any;
  reserveFlag?: boolean;
  warehouses?: Warehouse[];
};
export function OutOfStock(props: Props) {
  const {
    ShowCentralStockTtypeSkuV2,
    centralStock,
    localStock,
    productType,
    reserveFlag,
    warehouses,
  } = props;
  const translate = useTranslate();
  const { formatDate } = useLocalization();
  const outOfStockBackofficeKey = useFeatureFlag('X4C_OutOfStock_Display_Text');

  const parseDate = (dateString: string) => {
    return formatDate(dateString, 'MMM dd');
  };

  const filterWarehouse =
    warehouses !== null && warehouses !== undefined
      ? warehouses.filter(
          (r: any) =>
            r.quantityOnOrder !== null &&
            r.quantityOnOrder !== undefined &&
            r.quantityOnOrder.length > 0
        )
      : [];

  const getQuantityOnOrder = () => {
    if (
      filterWarehouse !== null &&
      filterWarehouse !== undefined &&
      filterWarehouse.length > 0
    ) {
      const quantityOnOrderArray: QuantityOnOrder[] = [];
      filterWarehouse.forEach((warehouse) => {
        if (
          warehouse.quantityOnOrder !== null &&
          warehouse.quantityOnOrder !== undefined &&
          warehouse.quantityOnOrder.length > 0
        ) {
          warehouse.quantityOnOrder.forEach((quantiTyOnOrder) => {
            quantityOnOrderArray.push(quantiTyOnOrder);
          });
        }
      });

      return quantityOnOrderArray.sort((a, b) =>
        Date.parse(a.date) > Date.parse(b.date) ? 1 : -1
      );
    }
  };

  const getOutOfStockText = () => {
    const quanityOnOrder = getQuantityOnOrder();
    if (
      quanityOnOrder !== null &&
      quanityOnOrder !== undefined &&
      quanityOnOrder.length > 0
    ) {
      if (quanityOnOrder[0].quantity > 0) {
        const OutofstockText =
          `${quanityOnOrder[0].quantity}` +
          ` ` +
          `${translate('Common.Arriving')}` +
          ` `;

        return OutofstockText;
      } else {
        const OutofstockText = `${translate('Common.Arriving')}`;
        return OutofstockText;
      }
    } else {
      return translate('Common.Outofstock');
    }
  };

  const getETADate = () => {
    const quanityOnOrder = getQuantityOnOrder();
    if (
      quanityOnOrder !== null &&
      quanityOnOrder !== undefined &&
      quanityOnOrder.length > 0 &&
      quanityOnOrder[0].date !== undefined &&
      quanityOnOrder[0].date !== null &&
      quanityOnOrder[0].date !== ''
    ) {
      return parseDate(quanityOnOrder[0].date);
    } else return '';
  };

  function getNumV2(val: any) {
    if (isNaN(val)) {
      return 0;
    }
    return val;
  }

  return (
    <>
      <Typography
        color={
          centralStock === 0 && localStock === 0
            ? '#B11616'
            : [
                getNumV2(centralStock) > 0 &&
                getNumV2(localStock) <= 0 &&
                (productType === null || productType === '') &&
                ShowCentralStockTtypeSkuV2
                  ? '#B11616'
                  : '#18846F',
              ]
        }
        component="span"
        sx={{
          borderRadius: '6px',
          cursor:
            centralStock === 0 && localStock === 0 ? 'pointer' : 'initial',
          fontSize: '0.87rem',
          fontWeight: '600',
          lineHeight: '19px',
          padding: '0px',
        }}
        variant="body2"
      >
        <Stack
          alignItems="center"
          direction="row"
          divider={
            props.reserveFlag && (
              <Divider
                flexItem
                orientation="vertical"
                sx={{
                  borderColor: '#C4C4C4',
                  borderLeftWidth: '0px',
                  borderRightWidth: '1px',
                  color: '#18846F',
                  margin: '0px',
                }}
              />
            )
          }
          justifyContent="center"
        >
          <Box
            sx={{
              display: 'flex',
              marginRight: reserveFlag === true ? '0.50rem' : '0rem',
            }}
          >
            {outOfStockBackofficeKey !== undefined &&
            outOfStockBackofficeKey !== null &&
            Boolean(outOfStockBackofficeKey.value) === true &&
            outOfStockBackofficeKey.value !== undefined &&
            outOfStockBackofficeKey.value !== null &&
            outOfStockBackofficeKey.value === 'true'
              ? getOutOfStockText()
              : translate('Common.Outofstock')}

            {outOfStockBackofficeKey !== undefined &&
              outOfStockBackofficeKey !== null &&
              Boolean(outOfStockBackofficeKey.isReady) &&
              outOfStockBackofficeKey.value !== undefined &&
              outOfStockBackofficeKey.value !== null &&
              outOfStockBackofficeKey.value === 'true' && (
                <Typography
                  color="#B11616"
                  component="span"
                  sx={{
                    borderRadius: '6px',
                    cursor:
                      centralStock === 0 && localStock === 0
                        ? 'pointer'
                        : 'initial',
                    fontSize: '0.87rem',
                    fontWeight: '400',
                    lineHeight: '19px',
                    paddingLeft: '5px',
                    paddingRight: reserveFlag === true ? '5px' : '0px',
                  }}
                  variant="body2"
                >
                  {getETADate()}
                </Typography>
              )}
          </Box>

          {reserveFlag === true && (
            <div style={{ marginLeft: '0.50rem' }}>
              <ReservedIcon component="span">R</ReservedIcon>
            </div>
          )}
        </Stack>
      </Typography>
    </>
  );
}

const ReservedIcon = styled(Box)(() => ({
  alignItems: 'center',
  border: '3px solid #18846F',
  borderRadius: '10%',
  color: '#18846F',
  display: 'inline-flex',
  height: 22,
  justifyContent: 'center',
  width: 20,
}));
